import {
	createInteractionMetric,
	AI_CONTENT_CATCHUP_INTERACTION,
} from '@confluence/browser-metrics';

export const AI_CONTENT_CATCHUP_INTERACTION_METRIC = createInteractionMetric({
	key: AI_CONTENT_CATCHUP_INTERACTION,
});
